module.exports = __webpack_public_path__ + "img/Kfc Signature Box.a6adc4bc.png";